/// <amd-module name="Wit/Clients/SearchLegacy/RestClient/Search" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   search\client\webapilegacy\clientgeneratorconfigs\genclient.json
 */

import { IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import Code = require("Wit/Clients/SearchLegacy/Contracts/Code");
import WorkItem = require("Wit/Clients/SearchLegacy/Contracts/WorkItem");
import Search_Shared_Contracts = require("Wit/Clients/SearchLegacy/Contracts/Search.SharedLegacy");

export interface ISearchRestClient extends IVssRestClient {
    /**
     * Provides a set of results which match the posted advanced query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The advanced search query.
     * @param project - Project ID or project name
     */
    postAdvancedCodeQuery(query: Code.SearchQuery, project?: string): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId>;
    /**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
     * @param project - Project ID or project name
     */
    postCodeQuery(query: Code.SearchQuery, project?: string): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId>;
    /**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
     * @param project - Project ID or project name
     */
    postWorkItemQuery(query: WorkItem.WorkItemSearchRequest, project?: string): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId>;

	/**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
	 * @param entityType - the entity type
     * @param project - Project ID or project name
     */
    resultsCount(query: Search_Shared_Contracts.CountRequest, entityType: string, project?: string): Promise<Search_Shared_Contracts.CountResponse>;
}

class SearchRestClient extends RestClientBase implements ISearchRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Provides a set of results which match the posted advanced query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The advanced search query.
     * @param project - Project ID or project name
     */
    public async postAdvancedCodeQuery(
        query: Code.SearchQuery,
        project?: string
    ): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId> {

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/codeAdvancedQueryResults",
            routeValues: {
                project: project
            },
            body: query,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const activityIdHeader = response.headers.get("activityid");
            const result: Search_Shared_Contracts.EntitySearchResponseWithActivityId = {
                response: <Search_Shared_Contracts.EntitySearchResponse>body,
                activityId: activityIdHeader ? activityIdHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
     * @param project - Project ID or project name
     */
    public async postCodeQuery(
        query: Code.SearchQuery,
        project?: string
    ): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId> {

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/codeQueryResults",
            routeValues: {
                project: project
            },
            body: query,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const activityIdHeader = response.headers.get("activityid");
            const result: Search_Shared_Contracts.EntitySearchResponseWithActivityId = {
                response: <Search_Shared_Contracts.EntitySearchResponse>body,
                activityId: activityIdHeader ? activityIdHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
     * @param project - Project ID or project name
     */
    public async postWorkItemQuery(
        query: WorkItem.WorkItemSearchRequest,
        project?: string
    ): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId> {

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/workItemQueryResults",
            routeValues: {
                project: project
            },
            body: query,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const activityIdHeader = response.headers.get("activityid");
            const result: Search_Shared_Contracts.EntitySearchResponseWithActivityId = {
                response: <Search_Shared_Contracts.EntitySearchResponse>body,
                activityId: activityIdHeader ? activityIdHeader.split(',') : []
            };
            return result;
        });
    }

	/**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
	 * @param entityType - the entity type
     * @param project - Project ID or project name
     */
    public async resultsCount(
        query: Search_Shared_Contracts.CountRequest,
        entityType: string,
        project?: string
    ): Promise<Search_Shared_Contracts.CountResponse> {

        const queryValues: { [key: string]: any } = {
            entityType: entityType
        };

        return this.beginRequest<Search_Shared_Contracts.CountResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/resultsCount",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            body: query
        });
    }
}

RestClients.add("Legacy.ISearchRestClient", {
    factory: SearchRestClient,
    options: {
        serviceInstanceType: "00000010-0000-8888-8000-000000000000"
    }
});
